export const PPTEditorStateType = {
    EDITABLE: 1,            // 可以编辑
    COPYABLE: 2,            // 可以复制元素
    SELECTABLE: 3,          // 可以选择元素
};

export type PPTEditorStateTypeValue = typeof PPTEditorStateType[keyof typeof PPTEditorStateType];

export enum PPTEditorStateEnumType {
    EDITABLE = PPTEditorStateType.EDITABLE, // 可以编辑
    COPYABLE = PPTEditorStateType.COPYABLE,            // 可以复制元素
    SELECTABLE = PPTEditorStateType.SELECTABLE,          // 可以选择元素
}
